import { ComponentPropsWithRef, useRef } from 'react';
import { Components } from 'react-virtuoso';
import { useSetTopListItemStyle } from 'src/components/Events/EventListing/EventVirtualizedList/EventVirtualizedList.hooks';
import { useSetTopListItemPosition } from 'src/components/Events/EventListing/EventVirtualizedList/useSetTopListItemPosition';
import { VirtuosoContext } from 'src/core/ui/Virtuoso/VirtuosoContext';
import { useUserHasFeature } from 'src/hooks/useUserHasFeature';
import { Feature } from 'src/WebApiController';

export const VirtuosoTopListItemWrapper: Components<
  unknown,
  VirtuosoContext
>['TopItemList'] = ({
  children,
  style,
  context,
}: ComponentPropsWithRef<'div'> & {
  context?: VirtuosoContext;
}) => {
  const topItemListRef = useRef<HTMLDivElement | null>(null);
  const isScrollAtTop = context?.scrollY === 0;

  const hasNoScrollDependencyOnVirtuosoFeature = useUserHasFeature(
    Feature.NoScrollDependencyOnVirtuoso
  );

  useSetTopListItemPosition(
    {
      topItemListRef,
      virtuosoId: context?.virtuosoId ?? '',
      isScrollAtTop,
      virtuosoScrollY: context?.scrollY ?? 0,
    },
    hasNoScrollDependencyOnVirtuosoFeature
  );

  useSetTopListItemStyle(
    {
      topItemListRef,
      virtuosoId: context?.virtuosoId ?? '',
    },
    !hasNoScrollDependencyOnVirtuosoFeature
  );

  return (
    <div
      ref={topItemListRef}
      style={{ ...style, zIndex: 2 }}
      data-is-top-item={true}
      data-is-scroll-at-top={isScrollAtTop}
    >
      {context?.topListItemBefore}
      {children}
    </div>
  );
};
